/**
 * 私域应用模块路由
 * 路径前缀: /desktopCenter/privateDomain/
 */
import type { RouteRecordRaw } from "vue-router";

export const privateDomainRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/privateDomain/pageDecoration",
		name: "PrivatePageDecoration",
		meta: {
			title: "页面装修",
			keepAlive: false,
		},
		redirect: "/desktopCenter/privateDomain/pageDecoration/pageList",
		children: [
			{
				path: "/desktopCenter/privateDomain/pageDecoration/pageList",
				name: "PrivateDomainPageList",
				meta: {
					title: "页面列表",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/diy_page",
				},
				component: () =>
					import("@main/views/Apps/PrivateDomain/PageDecoration/PageList/PageList.vue"),
			},
			{
				path: "/desktopCenter/privateDomain/pageDecoration/personalCenter",
				name: "PrivateDomainPersonalCenter",
				meta: {
					title: "个人中心",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/person_center_diy_page",
				},
				component: () =>
					import("@main/views/Apps/PrivateDomain/PageDecoration/PersonalCenter/PersonalCenter.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/privateDomain/navigationConfig",
		name: "PrivateNavigationConfig",
		meta: {
			title: "导航配置",
			keepAlive: false,
		},
		redirect: "/desktopCenter/privateDomain/navigationConfig/mobileNavigation",
		children: [
			{
				path: "/desktopCenter/privateDomain/navigationConfig/mobileNavigation",
				name: "MobileNavigation",
				meta: {
					title: "移动端导航",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/tabbar",
				},
				component: () =>
					import(
						"@main/views/Apps/PrivateDomain/NavigationConfig/MobileNavigation/MobileNavigation.vue"
					),
			},
			{
				path: "/desktopCenter/privateDomain/navigationConfig/linkManage",
				name: "LinkManage",
				meta: {
					title: "链接管理",
					keepAlive: false,
					iframeUrl: "cos.php/wdsxh/link",
				},
				component: () =>
					import("@main/views/Apps/PrivateDomain/NavigationConfig/LinkManage/LinkManage.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/privateDomain/wechatMiniProgram",
		name: "WechatMiniProgram",
		meta: {
			title: "微信小程序",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/config/index",
		},
		component: () =>
			import("@main/views/Apps/PrivateDomain/WechatMiniProgram/WechatMiniProgram.vue"),
	},
	{
		path: "/desktopCenter/privateDomain/officialAccountSettings",
		name: "OfficialAccountSettings",
		meta: {
			title: "公众号设置",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/config/index",
		},
		component: () =>
			import("@main/views/Apps/PrivateDomain/OfficialAccountSettings/OfficialAccountSettings.vue"),
	},
	{
		path: "/desktopCenter/privateDomain/douyinMiniProgram",
		name: "DouyinMiniProgram",
		meta: {
			title: "抖音小程序",
			keepAlive: false,
		},
		component: () =>
			import("@main/views/Apps/PrivateDomain/DouyinMiniProgram/DouyinMiniProgram.vue"),
	},
];
